module.exports = __webpack_public_path__ + "static/media/83.b79907e6.gif";